﻿import $ from "jquery";
import { GuiListGeneric } from "../GuiListGeneric";

export class GuiListFakturaAktionenChoose extends GuiListGeneric {

    constructor() {
        super("FakturaAktionen");
        this.checkBtnAddAktionen();
    }

    protected override attachListEvents() {
        super.attachListEvents();
        $("div.erz-list-element input:checkbox.form-check-input, label.form-check-label").on("click", (e) => { this.clickCheck(e); });
        $("#cball").on("click", (e) => this.clickCbAll(e));
    }

    override clickRow(): void {
        // keine Funktion in diesem Modul
    }

    clickCbAll(e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) {
        this.log("clickCbAll");

        e.preventDefault();
        e.stopPropagation();


        const url = $("div.erz-list").data("selectall-url") as string;
        this.lock();
        if ($("#cball").is(':checked')) {
            $.get(`${url}?state=true&t=${new Date().getTime()}`).done(() => { document.location.reload(); });
        } else {
            $.get(`${url}?state=false&t=${new Date().getTime()}`).done(() => { document.location.reload(); });
        }
    }

    checkBtnAddAktionen() {
        const anzchecked = $("input.checkaktion").filter(':checked').length;
        if (anzchecked > 0) {
            $("#btnAddAktionen").removeAttr("disabled");
        }
        else {
            $("#btnAddAktionen").attr("disabled", "disabled");
        }
    }

    // ret
    clickCheck(e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) {
        this.log("clickCheck");
        e.stopPropagation();

        const cb = $(e.target).closest("div.form-check").find("input:checkbox");
        const aktionId = cb[0].id;
        this.callSelect(aktionId);
    }

    private callSelect(aktionId: string) {
        const url = $("div.erz-list").data("select-url") as string;

        const urlSelect = url + "?aktionId=" + aktionId;
        $.get(urlSelect).done(() => {
            this.checkBtnAddAktionen();
        });
    }
}
